import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { imagePicker_template } from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
declare var ko: any;
export class imageWidget_template extends vnTemplate{
    public imagePicker: imagePicker_template;
    protected buildViewModel(): any {
        let self = this;
        let  vm = {
            idElementForImage   : ko.observable(self.idElement.concat('_')),
            viewMode            : ko.observable(''),
            imageId             : ko.observable(''),
            image               : ko.observable(null),
            imageURL            : ko.observable(''),
            imageCount          : ko.observable(''),
            selectedImages      : ko.observableArray([]),
            selectedImagesMarkup  : ko.observable(''),
            idStatus            : ko.observable(''),
            permissions         : ko.observableArray(this.initPermissions([])),
            isFeaturedTagActive : ko.observable(false),
            isPublishingControl : ko.observable(false),
            isGlobalLockEnabled : ko.observable(false),
            isFeaturedVideoActive : ko.observable(false),
            isFeaturedEmbedActive : ko.observable(false),
            imageIsPlaceholder : ko.observable(false),
            imageIsRequired: ko.observable(false),
            imageIsMobileOptimized: ko.observable(false),
            onClickAddImage     : function (data?) {
                self.addImage();
            },
            onClickEditImage    : function (data?) {
                self.editImage();
            },
            onClickViewImage    : function (data?) {
                self.viewImage();
            },
            onClickViewImagePicker: function (data?) {
                self.viewImagePicker();
            },
            onClickCloseImage   : function (data?) {
                self.closeImage()
            },
            onClickRemoveImage  :  function (data?) {
                self.removeImage()
            },
        };
        return {...vm }
    }
    protected initPartial() {
    }
    protected getTemplateHtml(): string {
        return `
            <!-- ko if: !isFeaturedTagActive() && viewMode() !== 'multi-select-no-gallery' -->
                 <button class="btn-form icon i-edit" data-bind="disable: isPublishingControl() || isGlobalLockEnabled() , event: { click: onClickEditImage }, visible: imageURL()"></button>
            <!-- /ko -->

            <!-- ko if: viewMode() !== 'multi-select-no-gallery' -->
            <!-- <button class="btn-form icon i-view>" data-bind=" event: { click: onClickViewImage },visible: imageURL()"></button> -->
            <!-- /ko -->

            <!-- ko if: (viewMode() == 'multi-select-no-gallery') && (selectedImages() && selectedImages().length > 0) -->
            <div class="w-img-group-count">
                <span><span data-bind="text: selectedImages().length"></span> Image<!-- ko if: selectedImages().length !== 1 -->s<!-- /ko --> in Group</span>
            </div>
            <!-- /ko -->

            <!-- ko if: (!isFeaturedTagActive() && !imageIsRequired()) || (selectedImages() && selectedImages().length > 0) -->
            <button class="btn-form icon i-delete" data-bind="disable: isPublishingControl() || isGlobalLockEnabled() , event: { click: onClickRemoveImage },visible: imageURL() || (selectedImages() && selectedImages().length > 0)"></button>
            <!-- /ko -->

            <!-- ko if: viewMode() !== 'multi-select-no-gallery' -->
            <div class="w-img" data-bind="visible: imageURL(), attr: {id: idElementForImage() }">
                <img data-bind="attr: { src: imageURL }"  alt="" />
                <button class="btn-form icon i-close" type="button" data-bind="event: { click: onClickCloseImage }"><span>close</span></button>
            </div>
            <!-- /ko -->

            <!-- ko if: !isFeaturedTagActive() && !imageIsRequired() -->
            <button class="btn-form icon i-image <!-- ko if: viewMode() == 'multi-select-no-gallery' -->picker<!-- /ko --> " type="button" data-bind="disable: isGlobalLockEnabled(), visible: idStatus() != 6 || (idStatus() == 6 && permissions()['article_edit_publishingControl'].write), event: { click: onClickAddImage }, css: { 'no-selection' : imageURL() == '' }">Select Image<!-- ko if: viewMode() == 'multi-select-no-gallery' -->s<!-- /ko --></button>
            <!-- /ko -->
        `;
    }
    protected getTemplateName(): string {
        return "imageWidget-template";
    }
    public setIdStatus(idStatus){
        this.getTemplateViewModel().idStatus(idStatus);
    }
    public setPermissions(permissions){
        this.getTemplateViewModel().permissions(permissions);
    }
    public setIsFeaturedTagActive(value) {
        this.getTemplateViewModel().isFeaturedTagActive(value);
    }
    public setIsFeaturedVideoActive(value) {
        this.getTemplateViewModel().isFeaturedVideoActive(value);
    }
    public setIsFeaturedEmbedActive(value) {
        this.getTemplateViewModel().isFeaturedEmbedActive(value);
    }
    public getImage(){
        return this.getTemplateViewModel().image();
    }
    public setImage(image){
        this.clearImage();
        if(image && image.id){
            this.imageIsPlaceHolder(false)
        }
        this.getTemplateViewModel().imageId(image.id);
        this.getTemplateViewModel().imageURL(image.url);
        this.getTemplateViewModel().imageIsMobileOptimized(image.isMobileOptimized||false);
        this.getTemplateViewModel().image(image);
    }
    public clearImage(){
        this.getTemplateViewModel().imageId('');
        this.getTemplateViewModel().imageURL('');
        this.getTemplateViewModel().imageIsMobileOptimized(false);
        this.getTemplateViewModel().image(null);
        this.caller.setIsImageOptimized(false);
    }
    public setMode(viewMode){
        this.getTemplateViewModel().viewMode(viewMode);
    }
    public addImage(target?, viewMode?): any {

        let helper = this.caller;

        if  (typeof helper.getImagePickerHelper === 'function') {
            helper = this.caller.getImagePickerHelper();
        }

        if ( this.idElement == 'tag_image_group' || this.idElement == 'default_tag_image_group' || this.idElement == 'images_spec_field' ) {
            helper.addImageGroup(this.idElement, this.getTemplateViewModel().viewMode(), this.getTemplateViewModel().selectedImages(), this);
        } else {
            helper.addImage(this.idElement, this.getTemplateViewModel().viewMode(), this);
        }
    }
    public viewImage(target?): any {
        this.caller.viewImage(this.getTemplateViewModel().idElementForImage());
    }
    public viewImagePicker(){
        this.caller.showImagePicker(this.getTemplateViewModel().viewMode(), this.idElement, this);
    }

    public editImage(target?, viewMode?): any {

        this.caller.editImage(this.idElement, this.getTemplateViewModel().viewMode(), this);
    }
    public closeImage(target?) : any {
        this.caller.closeImage(this.getTemplateViewModel().idElementForImage());
    }
    public removeImage(target?){

        if (this.idElement !== 'tag_image_group' && this.idElement !== 'default_tag_image_group' &&  this.idElement !== 'images_spec_field' ){
            this.caller.removeImage(this.idElement, this);
        } else if (this.idElement == 'tag_image_group' || this.idElement === 'default_tag_image_group' || this.idElement === 'images_spec_field' ){
            this.getTemplateViewModel().selectedImages([]);
            this.getTemplateViewModel().selectedImagesMarkup('');
            this.caller.removeImageGroup(this.idElement, this);
        }
    }
    public setIsPublishingControl(value : boolean){
        this.getTemplateViewModel().isPublishingControl(value);
    }
    public setIsGlobalLockEnabled(value : boolean){
        this.getTemplateViewModel().isGlobalLockEnabled(value);
    }

    public getSelectedImagesCount(){
        return this.getTemplateViewModel().selectedImages().length;
    }
    public getSelectedImages(){
        return this.getTemplateViewModel().selectedImages();
    }
    public setSelectedImages(selectedImages){
        this.getTemplateViewModel().selectedImages(selectedImages);
    }

    public getSelectedImagesMarkup(){
        return this.getTemplateViewModel().selectedImagesMarkup();
    }
    public setSelectedImagesMarkup(selectedImagesMarkup){
        this.getTemplateViewModel().selectedImagesMarkup(selectedImagesMarkup);
    }

    public setPlaceHolderImage(location = "/assets/images/replace-video.png"){
        //Placeholder image does not have id and name
        this.imageIsPlaceHolder(true);
        this.clearImage();
        this.getTemplateViewModel().imageId(null);
        this.getTemplateViewModel().imageURL(location);
        this.getTemplateViewModel().image({id : null ,name : null, url : location});
    }
    public imageIsRequired(value : boolean){
        //Cannot be deleted or and select button will not be visible on the widget
        this.getTemplateViewModel().imageIsRequired(value);
    }
    private imageIsPlaceHolder(value : boolean){
        this.getTemplateViewModel().imageIsPlaceholder(value);
    }

    public setCaller(caller){
        this.caller = caller;
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/imageWidget_template.ts